<template>
  <div id="editAccountNamePopUpWrapper">
    <custom-popup :isVisibleProp="true" class="common-gradient">
      <template #title>
        <div @click="handleCloseEditAccountNameForm" class="close-icon el-icon-close">
          <el-icon><Close /></el-icon>
        </div>
        <div class="title">{{ $t('label.accountName') }}</div>
      </template>
      <template #body>
        <el-form :model="editAccountNameForm" :rules="editAccountNameFormRules" ref="editAccountNameForm" class="edit-account-name-form" @submit.prevent>
          <!-- Account Name -->
          <el-form-item class="accountName f-item" prop="accountName">
            <el-input v-model="editAccountNameForm.accountName"
            :placeholder="$t('label.accountName')"
            @focus="fieldEventCommonStyle('focus', 'input-accountName', 'white')"
            @blur="fieldEventCommonStyle('blur', 'input-accountName', 'white')"
            class="cstm-input-white input-accountName">
            </el-input>
            <div v-if="error.length > 0" class="animated shake backend-error-msg target-el-form-item_accountName">{{error}}</div>
          </el-form-item>
        </el-form>

        <div class="error-message" v-if="showEditAccountNameError">
          {{editAccountNameError}}
        </div>
      </template>

      <template #footer>
        <el-button @click="handleEditAccountNameFormSubmit" class="cstm-btn-white width-auto">{{$t('label.saveChanges')}}</el-button>
      </template>
    </custom-popup>
  </div>
</template>

<script src="./edit-account-name-dialog.js"></script>
<style lang="scss" src="./edit-account-name-dialog.scss"></style>
